import React from "react";

const AlphaContext = React.createContext({});

export default AlphaContext;
